import { DocumentMetaType } from '/@/modules/document/constants/DocumentMetaType';
import { DocumentOtherMeta } from '/@/modules/document/models/meta/DocumentOtherMeta';
import { DocumentType } from '/@/modules/document/enums/DocumentType';
import { DocumentSubType } from '/@/modules/document/enums/DocumentSubType';
import { DocumentAdministrationLetterMeta } from '/@/modules/document/models/meta/DocumentAdministrationLetterMeta';
import { DocumentMarriageContractMeta } from '/@/modules/document/models/meta/DocumentMarriageContractMeta';
import { DocumentWillMeta } from '/@/modules/document/models/meta/DocumentWillMeta';
import { DocumentGrantOfProbateMeta } from '/@/modules/document/models/meta/DocumentGrantOfProbateMeta';
import { DocumentClosingLetterMeta } from '/@/modules/document/models/meta/DocumentClosingLetterMeta';
import { DocumentDriversLicenseMeta } from '/@/modules/document/models/meta/DocumentDriversLicenseMeta';
import { DocumentBankStatementMeta } from '@/modules/document/models/meta/DocumentBankStatementMeta';
import { DocumentPassportMeta } from '@/modules/document/models/meta/DocumentPassportMeta';

export class DocumentMeta {
  /**
   * @param model
   * @param meta
   * @returns {DocumentOtherMeta| DocumentAdministrationLetterMeta | DocumentClosingLetterMeta | DocumentDriversLicenseMeta | DocumentPassportMeta | DocumentGrantOfProbateMeta | DocumentMarriageContractMeta | DocumentWillMeta | null}
   */
  static factory(model, meta = {}) {
    switch (model.metaType) {
      case DocumentMetaType.DOCUMENT_OTHER_META:
        return DocumentOtherMeta.mapModel({ ...model.meta, ...meta });
      case DocumentMetaType.DOCUMENT_ADMINISTRATION_LETTER_META:
        return DocumentAdministrationLetterMeta.mapModel({ ...model.meta, ...meta });
      case DocumentMetaType.DOCUMENT_BANK_STATEMENT_META:
        return DocumentBankStatementMeta.mapModel({ ...model.meta, ...meta });
      case DocumentMetaType.DOCUMENT_CLOSING_LETTER_META:
        return DocumentClosingLetterMeta.mapModel({ ...model.meta, ...meta });
      case DocumentMetaType.DOCUMENT_DRIVERS_LICENSE_META:
        return DocumentDriversLicenseMeta.mapModel({ ...model.meta, ...meta });
      case DocumentMetaType.DOCUMENT_PASSPORT_META:
        return DocumentPassportMeta.mapModel({ ...model.meta, ...meta });
      case DocumentMetaType.DOCUMENT_GRANT_OF_PROBATE_META:
        return DocumentGrantOfProbateMeta.mapModel({ ...model.meta, ...meta });
      case DocumentMetaType.DOCUMENT_MARRIAGE_CONTRACT_META:
        return DocumentMarriageContractMeta.mapModel({ ...model.meta, ...meta });
      case DocumentMetaType.DOCUMENT_WILL_META:
        return DocumentWillMeta.mapModel({ ...model.meta, ...meta });
      default:
        return null;
    }
  }

  /**
   * @param model
   * @returns {string|null}
   */
  static getMetaType(model) {
    return (
      DocumentSubType.getByKey(model.subType)?.metaType ??
      DocumentType.getByKey(model.type)?.metaType ??
      null
    );
  }
}
